const stripUrlPlaceholder = (url: string) => {
  if (!url.startsWith('/puls24at')) {
    return url;
  }
  return url.replace(/^\/[a-z0-9]+/, '') || '/';
};

export default stripUrlPlaceholder;
